import React, {Fragment, useEffect, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {XMarkIcon} from '@heroicons/react/24/outline'
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {
    addEventAttribute,
    adminActionCard,
    adminArtistCard,
    adminEventCard,
    adminVenueCard,
    getAttribute,
    manageActionItem,
    manageEventCard, MetaTags,
    setUniqueEventAttribute,
    smallSchemaArtistCard,
    smallSchemaVenueCard,
    toastSuccess
} from "../../components/common/utilities";
import {ToastContainer} from "react-toastify";
import {ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDoubleLeftIcon} from "@heroicons/react/16/solid";
import {MagnifyingGlassIcon} from "@heroicons/react/20/solid";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import MapboxGeocoding from "@mapbox/mapbox-sdk/services/geocoding";
import FindVenues from "../venues/findVenues";
import FindVenuesNear from "../venues/findVenuesNear";
import FindPerformer from "../performers/findPerformers";

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function Adminactions() {
    const navigate = useNavigate();
    const logout = () => {
        window.location.href = '/logout';
    }

    let params = useParams();
    const venueID = params.venueID;
    const loaderdata = useLoaderData() as any;
    //console.log(loaderdata);
    const today = new Date();
    const dateString = today.toISOString().split('T')[0];

    const [isLoading, setIsLoading] = useState(false);

    const [events, setEvents] = useState([]);
    const [sortCreated, setSortCreated] = useState(false);
    const [nextOffset, setNextOffset] = useState("");
    const [previousOffset, setPreviousOffset] = useState("");
    const [currentOffset, setCurrentOffset] = useState("");

    const [isEnd, setIsEnd] = useState(true);
    const [totalSize, setTotalSize] = useState(0);
    const [edp, setEDP] = useState([]);
    const [eventOffset, setEventOffset] = useState(0);
    const [eventLimit, setEventLimit] = useState(10);
    const [NLPStatus, setNLPStatus] = useState([]);
    const [NLPUrl, setNLPUrl] = useState([]);
    const [NLPData, setNLPData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addingEvent, setAddingEvent] = useState(false)
    const [gettingEvents, setGettingEvents] = useState(false)
    const [importString, setImportString] = useState('');
    const [query, setQuery] = useState('');
    const [actionFilter, setActionFilter] = useState('createvenue');
    const [artistData, setArtistData] = useState([]);

    const [viewport, setViewport] = useState({
                                                 latitude: 0,   // Initial latitude
                                                 longitude: 0,  // Initial longitude
                                                 zoom: 1, width: '100vw', height: '100vh',
                                             });

    const _onClick = (event) => {
        console.log(`Clicked at latitude: ${event.lngLat[1]}, longitude: ${event.lngLat[0]}`);
    };

    var date = new Date();
    let adminCancelToken;


    function isUrlValid(string)
    {
        try
        {
            new URL(string);
            return true;
        }
        catch (err)
        {
            return false;
        }
    }

    const getEvents = (shouldPoll, sort, offset) => {
        console.log("getting events, created: ", sort);
        if (offset !== currentOffset)
        {
            window.scrollTo(0, 0);
            setEvents([]);
        }

        setGettingEvents(true)
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/actionlist.do`, {
            ticket: localStorage.getItem('ticket'), limit: 100, offset: offset, created: sort, query: query,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded',
                       }
                   }).then(function (response) {
            // handle success
            console.log("events", response);
            setEvents(response.data.collection);
            setNextOffset(response.data.pagination.nextOffset);
            setPreviousOffset(response.data.pagination.previousOffset);
            setTotalSize(response.data.pagination.totalSize);
            setIsEnd(response.data.pagination.end);
            setGettingEvents(false)
        });
    }

    const toggleSort = (sort) => {
        console.log("toggle sort", sort);
        //setEvents([]);
        setActionFilter(sort);
    }
    let controller;

    const handleAdminSearchChange = (e) => {

        const searchTerm = e.target.value
        if (controller !== undefined && controller !== null)
        {
            console.log("Aborted previous request", controller.signal.aborted)

            //adminCancelToken.cancel("Operation canceled due to new request.")
            controller.abort()

        }
        controller = new AbortController();

        setQuery(searchTerm)


        //Check if there are any previous pending requests


        //Save the cancel token for the current request

        //adminCancelToken = axios.CancelToken.source()
        setEvents([])

        try
        {

            axios.get(`${process.env.REACT_APP_API_URL}/p/manage/event/list.do?q=${searchTerm}`,

                      {signal: controller.signal} //Pass the cancel token to the current request

            ).then(function (response) {

                console.log("Results for " + searchTerm + ": ", response.data)

                setEvents(response.data.collection)
            })

        }
        catch (error)
        {

            console.log(error)

        }
    }


    useEffect(() => {

        getEvents(false, sortCreated, currentOffset);

    }, []);

    // EDIT EVENT DIALOG

    const [open, setOpen] = useState(false);

    type SchemaEvent = {
        [key: string]: any; // ?? variable key
        name: string;
    };
    type SchemaLocation = {
        [key: string]: any; // ?? variable key
        name: string;
    };

    const [eventData, setEventData] = useState<SchemaEvent>();
    const [venueData, setVenueData] = useState<SchemaLocation>();


    const createEvent = (e) => {
        e.preventDefault();
        console.log('posting ', eventData);
        axios.post(`${process.env.REACT_APP_API_URL}/go/api/event/create.do`, eventData, {}).then(function (response) {
            // handle success
            console.log(response);
            //setRooms(response.data.collection);
            //window.location.href = '/onboarding/room/'+response.data.collection[0]['guid'];

        });
    }


    const viewEvent = (event, eventid) => {
        setEventData(null);
        setIsLoading(true);
        setOpen(true);
        axios.get(`${process.env.REACT_APP_API_URL}/p/api/event.do`, {
            params: {
                event: eventid, tiny: true, admin: true, ticket: localStorage.getItem('ticket'),
            }
        }).then(function (response) {
            // handle success
            //console.log(response);
            setIsLoading(false);
            let eventData = response.data;
            setEventData(eventData);

        }).catch(function (error) {
            // handle error
            console.log(error);
            setIsLoading(false);
        });

    }

    const viewArtist = (event, eventid) => {
        setArtistData(null);
        setVenueData(null);
        setIsLoading(true);
        setOpen(true);
        axios.get(`${process.env.REACT_APP_API_URL}/p/api/artist.do`, {
            params: {
                artist: eventid, tiny: true, admin: true, ticket: localStorage.getItem('ticket'),
            }
        }).then(function (response) {
            // handle success
            //console.log(response);
            let artistData = response.data;
            setIsLoading(false);
            setArtistData(artistData);

        });

    }

    const viewVenue = (event, eventid) => {
        setVenueData(null);
        setArtistData(null);
        setOpen(true);
        axios.get(`${process.env.REACT_APP_API_URL}/p/api/venue.do`, {
            params: {
                venue: eventid, light: true, admin: true, ticket: localStorage.getItem('ticket'),
            }
        }).then(function (response) {
            // handle success
            //console.log(response);
            let venueData = response.data;
            setVenueData(venueData);

            if (response.data.geo && response.data.geo.latitude)
            {
                mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
                setTimeout(() => renderMap(response.data.geo.latitude, response.data.geo.longitude), 1000);
            }

        });

    }

    const renderMap = (latitude, longitude) => {
        const map = new mapboxgl.Map({
                             container: 'map',
                             style: 'mapbox://styles/mapbox/streets-v11',
                             center: [longitude, latitude],
                             zoom: 14,
                         });
        const startMarker = new mapboxgl.Marker()
            .setLngLat([longitude, latitude])
            .addTo(map);
    }


    const changeName = e => {
        e.preventDefault();
        alert('change name');
        /*axios.post(`${process.env.REACT_APP_API_URL}/keepsapi/api/createroom.do`, {
            instance: 'keeps',
            ticket: localStorage.getItem('ticket'),
            property: data['guid'],
            title: roomtitle,
            description: roomdescription,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            //setRooms(response.data.collection);
            window.location.href = '/onboarding/room/'+response.data.collection[0]['guid'];

        });*/
    }

    function changeStartDate(e)
    {
        console.log(e._d);
        var d = new Date(e._d);
        console.log(d.toISOString());
        setEventData({
                         ...eventData, localStartDate: e._i
                     })
    }

    function changeEndDate(e)
    {
        console.log(e._d);
        var d = new Date(e._d);
        console.log(d.toISOString());
        setEventData({
                         ...eventData, localEndDate: e._i
                     })
    }

    function clickedEvent(e)
    {
        console.log("clicked", e.target);

        let button = e.target.dataset.button;
        if(button === 'setAd')
        {
            console.log('setAd');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key,value,unique,remove,eventid);

            toastSuccess('Event updated');

        }
        else if(button === 'setPrivate')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key,value,unique,remove,eventid);

            toastSuccess('Event set to private');

        }
        else if(button === 'viewEvent')
        {
            let eventid = e.target.dataset.eventid;
            viewEvent(null,eventid);
        }
        else if(button === 'viewArtistOrVenue')
        {
            let artistid = e.target.dataset.artistid;
            let venueid = e.target.dataset.venueid;
            if(artistid)
            {
                viewArtist(null,artistid);
            }
            else if(venueid)
            {
                viewVenue(null,venueid);
            }
        }
        else if(button === 'resolveActionItem')
        {
            let actionid = e.target.dataset.actionid;
            manageActionItem("resolve",actionid);
        }

        else if(button === 'viewVenue')
        {
            let eventid = e.target.dataset.venueid;
            viewVenue(null,eventid);
        }
        else if(button === 'editVenue')
        {
            let eventid = e.target.dataset.venueid;
            window.open(`${process.env.REACT_APP_API_URL}/go/editvenue.do#!/venue/` + eventid, '_blank')

        }
        else if(button === 'editPerformer')
        {
            let eventid = e.target.dataset.performerid;
            window.open(`${process.env.REACT_APP_API_URL}/go/adminartists.do#!/artist/` + eventid, '_blank')

        }
        else if(button === 'setAttractionType')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key,value,unique,remove,eventid);

            toastSuccess('Attraction Type set to '+value);

        }

        else if(button === 'addAttribute')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = false;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            addEventAttribute(key,value,unique,eventid);

            toastSuccess('Attribute '+key+' set to '+value);

        }

        else if(button === 'manageAudience')
        {
            console.log('managing audience');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = false;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            addEventAttribute('pgg.audience.'+key,'pgg.audience.'+value,remove,eventid);

            toastSuccess('Audience set '+key+' Remove: '+remove);

        }

        /*let venueid = e.target.dataset.venueid;
        if (venueid !== undefined)
        {
            console.log(`Event bubbled up to div from `, venueid);
            //console.log(eventData);
            let venuename = e.target.dataset.venuename;
            let venueimage = e.target.dataset.venueimage;

            var locationData = eventData.location;
            locationData.name = venuename;
            locationData.image = venueimage;
            locationData['@id'] = venueid;

            setVenueData(locationData);

            setEventData({
                             ...eventData, location: {
                    locationData
                }

                         })
            console.log(eventData);

        }*/


    }

    const importURL = (event,eventurl) => {
        console.log(event);
        event.currentTarget.classList.toggle('fa-spin');
        setAddingEvent(true)
        if (!isUrlValid(eventurl))
        {
            alert("Invalid URL");
            return;
        }
        else
        {
            axios.post(`${process.env.REACT_APP_API_URL}/p/api/event/import.do`, {
                eventurl: eventurl,
                importmore: true,
                ticket: localStorage.getItem('ticket')
            }, {
                           headers: {
                               'Content-Type': 'application/x-www-form-urlencoded'
                           },
                       }).then(function (response) {
                // handle success
                //event.target.elements.text.value = '';
                setAddingEvent(false)
                event.currentTarget.classList.toggle('fa-spin');
                getEvents(null,sortCreated,0);
            }).catch(function (error) {
                // handle error
                console.log(error);
                setAddingEvent(false)

            });
        }

    }

    const importEvent = (event) => {
        event.preventDefault()
        setAddingEvent(true)
        if (!isUrlValid(event.target.elements.text.value))
        {
            alert("Invalid URL");
            setImportString('');
            setAddingEvent(false)
            return;
        }
        else
        {
            axios.post(`${process.env.REACT_APP_API_URL}/p/api/event/import.do`, {
                eventurl: event.target.elements.text.value,
                ticket: localStorage.getItem('ticket'),
                importmore: true
            }, {
                           headers: {
                               'Content-Type': 'application/x-www-form-urlencoded'
                           },
                       }).then(function (response) {
                // handle success
                event.target.elements.text.value = '';
                setAddingEvent(false)
                setImportString('');
                getEvents(null,sortCreated,0);
            }).catch(function (error) {
                // handle error
                console.log(error);
                setAddingEvent(false)

            });
        }

    }

    const showCard = (event,counter) => {
        if(getAttribute(event,'reason') === actionFilter)
        {
            return adminActionCard(event,counter);
        }
        return null;
    }

    const handlePasteImport = event => {
        var eventurl = event.clipboardData.getData('text');
        setImportString(eventurl);
        setAddingEvent(true)
        if (!isUrlValid(eventurl))
        {
            alert("Invalid URL");
            setImportString('');
            return;
        }
        else
        {
            axios.post(`${process.env.REACT_APP_API_URL}/p/api/event/import.do`, {
                eventurl: eventurl,
                ticket: localStorage.getItem('ticket')
            }, {
                           headers: {
                               'Content-Type': 'application/x-www-form-urlencoded'
                           },
                       }).then(function (response) {
                // handle success
                setAddingEvent(false)
                getEvents(null,sortCreated,0);
                setImportString('');
            }).catch(function (error) {
                // handle error
                console.log(error);
                setAddingEvent(false)

            });
        }
    };

    return <>
        <MetaTags
            title='Admin Actions'
            description='Au�velda�u menningarumfj�llunina'
            image='https://promogogo.com/cdn-cgi/image/fit=contain,width=768/https://media.promogogo.com/ymsirvidburdir/2024-06-10/3666078aaa094262b626960bf705498b.png'
            name='Team Mobilitus'
        />
        <div className="min-h-full">
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40" onClose={setOpen}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-2">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                                            <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll overflow-x-hidden py-1">

                                                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                                    {eventData && eventData.name && <div className="px-4 py-5 sm:p-6"
                                                                                         onClick={(event) => clickedEvent(event)}>
                                                        {adminEventCard(eventData)}
                                                    </div>}
                                                    {artistData && <div className="px-4 py-5 sm:p-6"
                                                                        onClick={(event) => clickedEvent(event)}>
                                                        {adminArtistCard(artistData)}
                                                        <FindPerformer venueData={artistData}/>
                                                    </div>}
                                                    {venueData && <div className="px-4 py-5 sm:p-6"
                                                                       onClick={(event) => clickedEvent(event)}>
                                                        {adminVenueCard(venueData)}
                                                        <FindVenues venueData={venueData} limit={50}  merge={false}/>
                                                        <FindVenuesNear venueData={venueData} limit={50}  merge={false}/>
                                                    </div>}


                                                    {venueData && <>
                                                    </>}
                                                    {isLoading &&
                                                     <div className="p-4 text-gray-800 flex justify-center">
                                                         <div className={'text-pg_yellow'}><i
                                                                 className="fa-2x fa-duotone fa-loader fa-spin"></i>
                                                         </div>
                                                     </div>}

                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                                                    onClick={() => setOpen(false)}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            <SidebarNavigation/>

            <div className="lg:pl-72">

                <main className="md:grid gap-4 grid-cols-1">
                    <div className="px-4 sm:px-6 lg:px-8">
                        {totalSize > 0 && <div className="p-2 text-sm text-gray-800">Total events: {totalSize}</div>}
                        <span className="bg-gray-100 p-2 text-sm text-gray-800"
                              onClick={() => toggleSort('createartist')}>Show Artists</span> <span
                        className="bg-gray-100 p-2 text-sm text-gray-800" onClick={() => toggleSort('createvenue')}>Show Venues</span>
                        <div>
                            <div className="px-4 sm:px-6 lg:px-2">
                                <nav
                                    className="sticky bg-white z-30 flex items-center justify-between px-4 sm:px-0  mt-2 mb-2"
                                    style={{top: "60px"}}>
                                    <div className="-mt-px flex w-0 flex-1">
                                        <div
                                            onClick={() => getEvents(null, sortCreated, 0)}
                                            className="cursor-pointer inline-flex items-center border-b-2 border-transparent pr-1 pb-2 pt-2 text-sm font-medium text-gray-500 hover:border-blue-500 hover:text-gray-700"
                                        >
                                            <ChevronDoubleLeftIcon className="mr-3 h-5 w-5 text-gray-400"
                                                                   aria-hidden="true"/>

                                        </div>
                                    </div>
                                    <div className="-mt-px md:flex">
                                        <div
                                            onClick={() => getEvents(null, sortCreated, previousOffset)}
                                            className="cursor-pointer inline-flex items-center border-b-2 border-transparent pr-1 pb-2 pt-2 text-sm font-medium text-gray-500 hover:border-blue-500 hover:text-gray-700"
                                        >
                                            <ArrowLongLeftIcon className="mr-3 h-5 w-5 text-gray-400"
                                                               aria-hidden="true"/>

                                        </div>
                                        <div
                                            onClick={() => getEvents(null, sortCreated, nextOffset)}
                                            className="cursor-pointer inline-flex items-center border-b-2 border-transparent pl-1 pb-2 pt-2 text-sm font-medium text-gray-500 hover:border-blue-500 hover:text-gray-700"
                                        >

                                            <ArrowLongRightIcon className="ml-3 h-5 w-5 text-gray-400"
                                                                aria-hidden="true"/>
                                        </div>

                                    </div>
                                    <div className="-mt-px flex w-0 flex-1 ">
                                        <div className={'justify-end mr-4 px-8'}>
                                            <form className="relative flex flex-1" action="#" method="GET">
                                                <label htmlFor="search-field" className="sr-only">
                                                    Search
                                                </label>
                                                <MagnifyingGlassIcon
                                                    className="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-400"
                                                    aria-hidden="true"
                                                />
                                                <input
                                                    id="search-field"
                                                    className="block h-full w-full rounded border-gray-200 p-2 pl-6 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm "
                                                    placeholder="Search admin..."
                                                    defaultValue={query}
                                                    type="search"
                                                    name="search"
                                                    onChange={e => handleAdminSearchChange(e)}
                                                />

                                            </form>
                                        </div>
                                    </div>
                                </nav>
                                {events && events.length > 0 && <ul onClick={(event) => clickedEvent(event)}>
                                    {events.map((event,index) => showCard(event,index))}
                                </ul>}
                                {events && events.length === 0 &&
                                 <div className="p-4 text-gray-800 flex justify-center">
                                     <div className={'text-pg_yellow'}><i
                                             className="fa-2x fa-duotone fa-loader fa-spin"></i></div>
                                 </div>}


                                <nav
                                    className="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0  mt-2 mb-2"
                                    id={'topnav'}>
                                    <div className="-mt-px flex w-0 flex-1">
                                        <div
                                            onClick={() => getEvents(null, sortCreated, 0)}
                                            className="cursor-pointer inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-blue-300 hover:text-gray-700"
                                        >
                                            <ChevronDoubleLeftIcon className="mr-3 h-5 w-5 text-gray-400"
                                                                   aria-hidden="true"/>

                                        </div>
                                    </div>
                                    <div className="hidden md:-mt-px md:flex">

                                        <div
                                            onClick={() => getEvents(null, sortCreated, previousOffset)}
                                            className="cursor-pointer inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                                        >
                                            <ArrowLongLeftIcon className="mr-3 h-5 w-5 text-gray-400"
                                                               aria-hidden="true"/>
                                        </div>
                                        <div
                                            onClick={() => getEvents(null, sortCreated, nextOffset)}
                                            className="cursor-pointer inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                                        >
                                            <ArrowLongRightIcon className="ml-3 h-5 w-5 text-gray-400"
                                                                aria-hidden="true"/>
                                        </div>
                                    </div>
                                    <div className="-mt-px flex w-0 flex-1 justify-end">

                                    </div>
                                </nav>


                                <div className="-mx-4 mt-2 sm:-mx-0">
                                </div>
                            </div>
                        </div>
                    </div>

                </main>
            </div>
        </div>
        <ToastContainer autoClose={800} theme={'dark'} />

    </>
}
